<template>
  <w-settings-content-template>
    <el-row type="flex" slot="content" justify="space-between">
      <el-col :span="14">
        <w-server-image-table class="mr-r20" @target-change="targetChange"/>
      </el-col>
      <el-col :span="10">
        <w-target-template-table :selected-image="selectedImage"/>
      </el-col>
    </el-row>
  </w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WServerImageTable from './components/ServerImageTable';
import WTargetTemplateTable from './components/TargetTemplateTable';

export default {
  name: 'WServerImageSetting',
  components: {
    WSettingsContentTemplate,
    WServerImageTable,
    WTargetTemplateTable,
  },
  data() {
    return {
      selectedImage: {},
    };
  },
  methods: {
    targetChange(data) {
      this.selectedImage = data;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/VirtualService/ServerImageSetting/index.vue